var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{path: '#'},"href":_vm.getUrl}},[_c('base-icon',{attrs:{"icon":_vm.getIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }